import { format } from '@10000/common'
import { Box, Icon, PopUpMenu } from '../../../widgets'
import { useState } from 'react'

export const CustomHeader = ({ column, onSort, sortDirection }) => (
  <Box gap={8} justifyContent="space-between" onClick={() => onSort(column.key)}>
    {column.name}
    {sortDirection === 'ASC'
      ? <Box alignItems="center">
          <Icon icon="ChevronUp" fill="black" size={20} />
        </Box>
      : sortDirection === 'DESC'
        ? <Box alignItems="center">
            <Icon icon="ChevronDown" fill="black" size={20} />
          </Box>
        : <Box alignItems="center">
            <Icon icon="Minus" fill="black" size={20} />
          </Box>
    }
  </Box>
)

export const DateFormatter = props => {
  const value = props.row[props.column.key]
  if(value === 0) {
    return 'Not Found'
  } else if (value === -1) {
    return 'Not Complete'
  } else {
    return format.ddmmyyyy(value)
  }
}

export const TimeDifferenceFormatter = props => `${Math.floor(props.row[props.column.key] / (1000 * 60))} minutes`

export const MoneyFormatter = props => `$${props.row[props.column.key]}`

export const InstanceMenuFormatter = props => {
  const [openSettings, setOpenSettings] = useState(false)
  const openShivoo = () => window.open(`http://localhost:3005/shivoo/?instanceId=${props.row['id']}&region=${props.row['region']}&view=presenter`)

  return (
    <>
      <Box cursor="pointer" onClick={() => setOpenSettings(true) } fullWidth fullHeight justifyContent="center" alignItems="center">
        <Icon icon="VerticalDots" fill="black" />
      </Box>
      <Box position="absolute" top={5} left="45%">
        <PopUpMenu
          open={openSettings}
          onClose={() => setOpenSettings(false)}
          width={180}
          items={!props.row['exited'] ? [{ text: 'Open game', onClick: openShivoo }] : []}
        />
      </Box>
    </>
  )
}
